import type { WidgetProps } from '../../types';
import BooleanWidget from '../widgets/boolean';
import EnumWidget from '../widgets/enum';
import NumberWidget from '../widgets/number';
import StringWidget from '../widgets/string';

export type ScalarFieldProps = {
  // The connect types have a problem with these
  readonly onChangeSilent: any;
  readonly ui: any;
} & WidgetProps;

export function ScalarField({
  resolveRef,
  formName,
  path,
  schema,
  schemaPath,
  value,
  ui,
  error,
  onChange,
  onChangeSilent,
  onBlur,
  onFocus,
  setUI,
  config,
  context,
  isRequired,
  widgets,
  disabled,
  readOnly,
  locale
}: ScalarFieldProps) {
  const widgetProps = {
    resolveRef,
    formName,
    path,
    schema,
    schemaPath,
    value,
    ui,
    error,
    onChange,
    onChangeSilent,
    onBlur,
    onFocus,
    setUI,
    config,
    context,
    isRequired,
    widgets,
    disabled: disabled ?? config.get('disabled'),
    readOnly,
    locale
  };

  if (widgets && config) {
    const widgetName = config.get('widget');
    if (widgets[widgetName]) {
      const Widget = widgets[widgetName];
      return <Widget {...widgetProps} />;
    }
  }

  if (schema.get('enum') ?? schema.get('oneOf')) {
    return <EnumWidget {...widgetProps} />;
  }

  if (schema.get('type') === 'boolean') {
    return <BooleanWidget {...widgetProps} />;
  }

  if (schema.get('type') === 'number' || schema.get('type') === 'integer') {
    return <NumberWidget {...widgetProps} />;
  }

  if (schema.get('type') === 'string') {
    return <StringWidget {...widgetProps} />;
  }

  throw new Error('Unknown widget type');
}

export default ScalarField;
